import React, { useRef } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Alert from "../common/Alert";
import { resetPassword } from "../../store/auth-slice";
import { uiActions } from "../../store/ui-slice";

const ResetPasswordForm = (props) => {
  const params = useParams();
  const dispatch = useDispatch();

  const notification = useSelector((state) => state.ui.notification);

  const passwordInputRef = useRef();
  const retypedPasswordInputRef = useRef();

  const resetButtonHandler = (event) => {
    event.preventDefault();
    if (
      passwordInputRef.current.value !== retypedPasswordInputRef.current.value
    ) {
      dispatch(uiActions.enqueNotification({
        mesage: "Invalid password or not identical",
        variant: "error"
      }));
      return;
    }
    dispatch(resetPassword(passwordInputRef.current.value, params.token));
  };

  return (
    <form className={props.classes.form} noValidate>
      <TextField
        inputRef={passwordInputRef}
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="new-password"
        name="new-password"
        label="New password"
        type="password"
        autoFocus
      />
      <TextField
        inputRef={retypedPasswordInputRef}
        variant="outlined"
        margin="normal"
        required
        fullWidth
        name="retyped-password"
        label="Retype password"
        type="password"
        id="retyped-password"
      />
      {notification && (
        <Alert severity={notification.variant}>{notification.message}</Alert>
      )}
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        onClick={resetButtonHandler}
        className={props.classes.submit}
      >
        Reset
      </Button>
    </form>
  );
};

export default ResetPasswordForm;
